import { takeEvery, put, fork } from "redux-saga/effects";
import { syncFirebasePath } from "sagas/firebase/internal-lib";
import * as actionTypes from "constants/actionTypes";

export function* replaceSystemStatus(data) {
  yield put({
    type: actionTypes.REPLACE_SYSTEM_STATUS,
    payload: data || {}
  });
}

export function* replaceIntegrationTypes(data) {
  yield put({
    type: actionTypes.REPLACE_INTEGRATION_TYPES,
    payload: data || {}
  });
}

/**
 * Syncs the overall system status reducer, which currently contains
 * broadcast notices, but may contain environment variables in the future.
 *
 * @returns {IterableIterator<ForkEffect>}
 */

export function* syncTopLevelDataWithFirebase() {
  yield fork(
    syncFirebasePath,
    `integration-types`,
    replaceIntegrationTypes,
    actionTypes.CANCEL_USER_SYNC
  );

  yield fork(
    syncFirebasePath,
    `system-status`,
    replaceSystemStatus,
    actionTypes.CANCEL_USER_SYNC
  );
}

export default function* topLevelData() {
  yield takeEvery(
    actionTypes.SYNC_TOP_LEVEL_DATA_WITH_FIREBASE,
    syncTopLevelDataWithFirebase
  );
}
